<script lang="tsx" setup>
import { ref, watch } from "vue"
import { useMotion } from "@vueuse/motion"
import { useWindowSize } from "@vueuse/core"
import SVG_Letterform from "@/components/SVG_Letterform.vue"
import { letterforms } from "@/data/letterforms"
import { useSpring } from "@/composables/use-spring"

const { config } = useSpring("gentle")
const sectionRef = ref<HTMLElement>()
const { height: windowHeight } = useWindowSize()

useMotion(sectionRef, {
  initial: { height: 0 },
  enter: {
    height: Math.round((windowHeight.value * 2) / 3),
    transition: { ...config, delay: 500 },
  },
})

watch(windowHeight, h => {
  if (sectionRef.value)
    sectionRef.value.style.height = `${Math.round((h * 2) / 3)}px`
})
</script>

<template>
  <div class="fixed font-serif h-full inset-0 flex flex-col gap-0">
    <div
      class="h-1/3 bg-white"
      v-motion
      :initial="{ opacity: 0 }"
      :enter="{ opacity: 1, transition: { delay: 500, duration: 1000 } }"
    >
      <div class="h-full flex flex-col justify-between">
        <div class="grid lg:grid-cols-2 gap-4 lg:gap-0 w-full p-4 lg:p-0">
          <div class="h5 lg:hidden">
            <span class="italic">Critical Mass</span><br />
            Projects Review 2026
          </div>
          <div class="lg:p-8">
            <div class="h4 italic hidden lg:block">Critical Mass</div>
            <div class="h4 hidden lg:block">Projects Review 2026</div>
          </div>
          <div class="lg:p-8">
            <div class="h5 hidden lg:block">Launching Friday 19 June 2026</div>
          </div>
        </div>
        <div class="grid lg:grid-cols-2 items-end w-full p-4 lg:p-0">
          <div class="lg:p-8 leading-tight">
            <div>Architectural Association<br />School of Architecture</div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-2/3 relative">
      <div
        ref="sectionRef"
        class="flex lg:flex-row flex-col overflow-hidden absolute bottom-0 left-0 w-full"
      >
        <div class="flex-1 min-h-0 bg-[#0057BB]">
          <div class="h-full lg:p-8 p-4">
            <SVG_Letterform
              :masters="letterforms.c"
              :min-gap-scale="{ default: 4, lg: 8 }"
              :stroke-width="4"
              stroke="black"
              class="fill-[#9C883A]"
            />
          </div>
        </div>

        <div class="flex-1 min-h-0">
          <div class="h-full lg:p-8 p-4 bg-[#9C883A]">
            <SVG_Letterform
              :masters="letterforms.m"
              :min-gap-scale="{ default: 4, lg: 8 }"
              :stroke-width="4"
              stroke="black"
              class="fill-[#0057BB]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
